import { EVENT_TIMELINE_QUERY_VALUE_MAP } from '../constants/eventsFairs.constants';
import { EE_EMPTY_DATE_FALLBACK_VALUE } from '../constants/fields.const';
import { getUTCDate } from '../hooks/useFormatDate';
import { TEventsListingItem } from '../components/eventsListing/types/eventsListing.types';

const canShowEventCard = (eventItem: TEventsListingItem) => {
  // Events cards with past unPublish date needs to be hidden
  const { unPublishOn } = eventItem;
  let isTodayBeforeUnPublishOn = false;
  const todayDate = new Date();
  if (!unPublishOn || unPublishOn?.includes(EE_EMPTY_DATE_FALLBACK_VALUE) || todayDate <= getUTCDate(unPublishOn)) {
    isTodayBeforeUnPublishOn = true;
  }

  return isTodayBeforeUnPublishOn;
};

const getTimeline = (startDate: Date, endDate?: Date): keyof typeof EVENT_TIMELINE_QUERY_VALUE_MAP | '' => {
  const todayDate = new Date();
  if (startDate && todayDate < startDate) return 'UPCOMING';
  if (startDate && todayDate >= startDate) {
    if (endDate && todayDate <= endDate) return 'ONGOING';
    if (endDate && todayDate > endDate) return 'PAST';
  }
  return '';
};

const getEndOfDate = (date: string) => {
  const endOfStartDate = new Date(getUTCDate(date || ''));
  endOfStartDate.setHours(23);
  endOfStartDate.setMinutes(59);
  endOfStartDate.setSeconds(59);
  endOfStartDate.setMilliseconds(999);
  return endOfStartDate;
};

const getCanUseDate = (date?: string): boolean => {
  return !!(date && !date.startsWith(EE_EMPTY_DATE_FALLBACK_VALUE));
};

export { canShowEventCard, getTimeline, getEndOfDate, getCanUseDate };
